import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Icon,
    Typography,
} from '@material-ui/core'

const ConfirmationDialog = ({
    open,
    onConfirmDialogClose,
    text,
    title = 'confirm',
    onYesClick,
    yesButton = "Да",
    noButton = "Нет",
    yesColor = "primary",
    noColor = "default",
    yesVariant = "contained",
    noVariant = "outlined",
    showWarningIcon = true,
}) => {
    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
            onClose={onConfirmDialogClose}
            PaperProps={{ style: { borderRadius: 12 } }}
        >
            <DialogTitle style={{ padding: '16px 20px 8px 20px' }}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        {showWarningIcon ? (
                            <Icon fontSize="small" style={{ marginRight: 8, color: '#ff9800' }}>
                                warning_amber_rounded
                            </Icon>
                        ) : null}
                        <Typography variant="h6" style={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                    </div>
                    <IconButton size="small" onClick={onConfirmDialogClose}>
                        <Icon fontSize="small">close</Icon>
                    </IconButton>
                </div>
            </DialogTitle>

            <DialogContent style={{ padding: '8px 20px 0 20px' }}>
                <Typography component="div" variant="body2" color="textSecondary">
                    {text}
                </Typography>
            </DialogContent>

            <DialogActions style={{ padding: '16px 20px 20px 20px' }}>
                <Button variant={noVariant} color={noColor} onClick={onConfirmDialogClose}>
                    {noButton}
                </Button>
                <Button variant={yesVariant} color={yesColor} onClick={onYesClick}>
                    {yesButton}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationDialog
